import { Clock, Zap } from 'lucide-react'

import type { OutreachPreview } from 'src/lib/voe/outreachPreview'

/**
 * The one line under the contact fields that says what automation will do
 * with the contact being entered. Renders nothing without a preview.
 */
const OutreachPreviewLine = ({
  preview,
}: {
  preview: OutreachPreview | null | undefined
}) => {
  if (!preview) return null

  const willAct = preview.tone === 'will'
  const Icon = willAct ? Zap : Clock

  return (
    <div
      data-testid="outreach-preview"
      className={`flex items-start gap-2 rounded-md border px-3 py-2 text-xs ${
        willAct
          ? 'border-doubleNickel-brand-100 bg-doubleNickel-brand-25 text-doubleNickel-gray-700'
          : 'border-doubleNickel-warning-100 bg-doubleNickel-warning-50 text-doubleNickel-gray-700'
      }`}
    >
      <Icon
        size={13}
        aria-hidden
        className={`mt-0.5 shrink-0 ${
          willAct
            ? 'text-doubleNickel-brand-600'
            : 'text-doubleNickel-warning-600'
        }`}
      />
      <span>{preview.text}</span>
    </div>
  )
}

export default OutreachPreviewLine
